<div class="container-fluid">
  <app-header titleText="Payroll Summary Report" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null" class="container">
    <div class="row">
      <h5 class="col-sm-12" i18n>Please provide report criteria</h5>
    </div>
  </div>
  <div *ngIf="report">
    <div class="row header-text">

      <div class="col-md-4">
        <app-dealer-logo></app-dealer-logo>
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <span i18n>REPORT DEFINED:</span><br />
          <ng-template [ngIf]="parameters.startDate"><span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br /></ng-template>
          <ng-template [ngIf]="job"><span i18n>Job:</span> {{job.quote_Name}}<br /></ng-template>
          <ng-template [ngIf]="crew"><span i18n>Crew:</span> {{crew.crew_Name}}<br /></ng-template>
          <ng-template [ngIf]="fieldTechnician"><span i18n>Field Technician:</span> {{fieldTechnician.fieldTechnician_FirstName}} {{fieldTechnician.fieldTechnician_LastName}}<br /></ng-template>
        </p>
      </div>

    </div>

    <div class="content">
      <div class="quote-month-summary">
        <h2 i18n>Payroll Summary</h2>
        <div>
          <table class="table table-bidit">
            <thead>
              <tr>
                <th i18n>Technician</th>
                <th i18n>Date</th>
                <th i18n>Sqr Ftg</th>
                <th i18n>Rate</th>
                <th i18n>Hours</th>
                <th i18n>Labor Cost</th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-aggregate [ngForOf]="report.aggregates">
                <tr>
                  <td colspan="5">{{aggregate.quote_Name}}</td>
                  <td>
                    <a routerLink="/quote/{{aggregate.quote_ID}}" class="btn btn-bidit-submit" i18n>View</a>
                  </td>
                </tr>
                <tr *ngFor="let payroll of aggregate.details">
                  <td>
                    {{payroll.fieldTechnician_FirstName}} {{payroll.fieldTechnician_LastName}}
                  </td>
                  <td>
                      {{payroll.workOrder_Start | date: 'M/d/yyyy'}}
                  </td>
                  <td>{{payroll.workOrder_ActualSqrFtg}}</td>
                  <td>
                    ${{payroll.workOrderLabor_HourlyRate | number: '1.2-2'}}
                  </td>
                  <td>
                      {{payroll.workOrderLabor_HoursWorked | number: '1.0-4' }}
                  </td>
                  <td>
                    ${{payroll.workOrderLabor_HourlyRate * payroll.workOrderLabor_HoursWorked | number: '1.2-2'}}
                  </td>
                </tr>
                <tr class="log-summary-row">
                  <td>
                    {{aggregate.quote_Name}} <span i18n>Totals</span>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    ${{aggregate.laborCost | number: '1.2-2'}}
                  </td>
                </tr>
              </ng-template>
            </tbody>
            <tfoot>
              <tr class="log-summary-row">
                <td i18n>Totals</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  ${{report.laborCost | number: '1.2-2'}}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
